import { api, ApiErrors } from 'services/api'
import { message } from 'antd'

export const getUnitGroups = (id = '') => new Promise((resolve, reject) => {
  api.get(`unitgroups/${id}`)
    .then((response) => {
      if (response.ok) {
        resolve(response.data.data)
      } else {
        ApiErrors(response)
        reject()
      }
    })
})

export const createOrUpdateUnitGroup = (props) => new Promise((resolve, reject) => {
  const { _id, ...params } = props

  // If id, so we have to update the record, or we're gonna create
  const verb = _id ? 'put' : 'post'
  const url = _id ? `unitgroups/${_id}` : 'unitgroups'

  api[verb](url, params)
    .then((response) => {
      if (response.ok) {
        message.success(`${props.name} was ${_id ? 'successfully updated' : 'created successfully'}`)
        resolve()
      } else {
        ApiErrors(response)
        reject()
      }
    })
})

export const deleteUnitGroup = (id) => new Promise((resolve, reject) => {
  api.delete(`/unitgroups/${id}`)
    .then((response) => {
      if (response.ok) {
        message.success('Unit Group deleted successfully')
        resolve()
      } else {
        ApiErrors(response)
        reject()
      }
    })
})
